import { styled } from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const Wrapper = styled.div`
    background-color: ${colorsPalettes.carbon[0]};
    box-shadow: 0 3px 6px ${rgba(colorsPalettes.carbon[500], 0.08)};
    border-radius: 6px;
`;

export const LoaderWrapper = styled(Flex)`
    width: 100%;
    height: 310px;
    justify-content: center;
    align-items: center;
`;
